import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/adu-design-build-process.png";

const BlogADUDesignBuildProcess = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "The ADU Design Build Process Made Simple",
    "description": "One team. One process. No surprises. Learn how design-build simplifies your ADU project.",
    "datePublished": "2026-04-04",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/adu-design-build-process" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />
      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="The ADU design build process made simple" className="w-full rounded-2xl" />
      </div>
      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Blog
        </Link>
        <p className="text-sm text-muted-foreground mb-2">April 4, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">The ADU Design Build Process Made Simple</h1>
        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>A lot of homeowners hesitate to start because the process feels overwhelming.</p>
          <p>Design, permits, construction. Different people, different timelines, too many unknowns.</p>
          <p>That's why we keep everything under one team.</p>
          <p>At UDA ADU, the same group handles design, permitting, and construction. You're not chasing different companies or trying to connect the dots yourself.</p>
          <p>We focus on keeping the process clear. You know what's happening, what's next, and what to expect.</p>
          <p>Most issues in construction come from poor planning early on. When everything is aligned from the start, the project runs smoother.</p>
        </article>
        <BlogCTAButtons />
      </main>
      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogADUDesignBuildProcess;
